import './styles.scss'

const Input = ({ title, error, required, ...props }) => {
  return (
    <div className={`custom-input${error ? ' has-error' : ''}`}>
      <div className="label">
        {title}
        {required && <span className="required-mark"> *</span>}
      </div>

      <input required={required} {...props} />

      {error && <span className="error-msg">{error}</span>}
    </div>
  )
}

export default Input
